/**
 * 라디오 광장 게이트웨이(PICNIC-MB-FIELD-001 §6.7 — 진짜 보드 ↔ 광장 · 순수).
 *
 * 아이의 보드는 자기 라디오를 광장으로 보낼 수 없다(받기 처리기는 하나뿐이고 자기가 보낸 것은 듣지 못한다). 그래서 **따로 한 대**가
 * Bench '피크닉 놀이터' 의 '라디오 광장 게이트웨이 (그룹 n)' 블록만 돌리고 USB 로 이 탭에 꽂힌다. 그 보드가 시리얼로 보내는 줄:
 *   `GW1 G=<그룹>`(1초마다 — 게이트웨이라는 표시) · `RX <hex>`(교실 공중에서 들은 패킷 · readRawPacket 36바이트 = 시뮬레이터 패킷과 같은 꼴)
 * 이 탭이 보드로 쓰는 줄: `TX <hex>`(광장 · 내 시뮬레이터의 패킷 → 공중).
 * 되먹임을 막는 규칙: 공중에서 온 패킷(air)은 다시 공중으로 보내지 않는다 — 한 교실에 게이트웨이가 둘이어도 돌지 않는다(같은 교실 보드는 이미 직접 들었다).
 */

export type GatewayLine = { readonly kind: "hello"; readonly g: number } | { readonly kind: "rx"; readonly p: number[] };

const HELLO = /^GW1 G=(\d{1,3})$/;
const RX = /^RX ((?:[0-9a-fA-F]{2}){5,36})$/;

/** 보드 한 줄 → 게이트웨이 소식(아니면 null — 놀이터 연결 줄 PF1 등) */
export function parseGatewayLine(line: string): GatewayLine | null {
  const s = line.trim();
  const h = HELLO.exec(s);
  if (h) {
    const g = Number(h[1]);
    return g <= 255 ? { kind: "hello", g } : null;
  }
  const r = RX.exec(s);
  if (!r) return null;
  const hex = r[1]!;
  const p: number[] = [];
  for (let i = 0; i < hex.length; i += 2) p.push(parseInt(hex.slice(i, i + 2), 16));
  return { kind: "rx", p };
}

/** 패킷 → 보드로 쓸 줄(36바이트를 넘으면 자른다 — 보드 쪽 상한) */
export function txLine(p: readonly number[]): string {
  return "TX " + p.slice(0, 36).map((b) => (b & 0xff).toString(16).padStart(2, "0")).join("");
}

/** 게이트웨이 표시가 이만큼 끊기면 게이트웨이가 아니다(보드는 1초마다 보낸다) */
export const GATEWAY_STALE_MS = 3000;
